/** «Глава пройдена!»: the happy robo-cat, confetti once, three stat tiles, ПРОДОЛЖИТЬ. */
import type { CSSProperties } from 'react';
import { RoboCat } from '../../ui/RoboCat.tsx';

type Shape = 'rect' | 'strip' | 'diamond';
const CONFETTI: readonly { x: number; y: number; shape: Shape; color: number; rotate: number }[] = [
  { x: 8, y: 22, shape: 'rect', color: 0, rotate: 20 },
  { x: 18, y: 64, shape: 'strip', color: 1, rotate: -35 },
  { x: 26, y: 12, shape: 'diamond', color: 2, rotate: 0 },
  { x: 30, y: 80, shape: 'rect', color: 3, rotate: -10 },
  { x: 70, y: 18, shape: 'diamond', color: 0, rotate: 0 },
  { x: 78, y: 70, shape: 'strip', color: 2, rotate: 40 },
  { x: 88, y: 36, shape: 'rect', color: 1, rotate: 12 },
  { x: 92, y: 84, shape: 'rect', color: 3, rotate: 30 },
  { x: 62, y: 88, shape: 'strip', color: 1, rotate: -60 },
  { x: 12, y: 44, shape: 'diamond', color: 3, rotate: 0 },
];
const CONFETTI_COLORS = ['var(--green)', 'var(--blue)', 'var(--gold)', 'var(--orange)'];

export function LessonComplete({
  title,
  subtitle,
  xp,
  accuracy,
  newWords,
  continueLabel = 'Продолжить',
  onContinue,
}: {
  title: string;
  subtitle: string;
  xp: number;
  accuracy: number;
  newWords: number;
  continueLabel?: string;
  onContinue: () => void;
}) {
  return (
    <div className="complete">
      <div className="complete__hero">
        <div className="complete__confetti" aria-hidden="true">
          {CONFETTI.map((c, i) => (
            <span
              key={i}
              className={`confetti confetti--${c.shape}`}
              style={
                {
                  left: `${c.x}%`,
                  top: `${c.y}%`,
                  '--rot': `${c.rotate}deg`,
                  '--delay': `${i * 40}ms`,
                  background: CONFETTI_COLORS[c.color],
                } as CSSProperties
              }
            />
          ))}
        </div>
        <RoboCat size={150} state="happy" label="Робо-кот радуется" />
      </div>

      <h1 className="complete__title">{title}</h1>
      <p className="complete__subtitle han">{subtitle}</p>

      <dl className="complete__stats">
        <div className="stat-tile stat-tile--gold">
          <dt>Опыт</dt>
          <dd>+{xp}</dd>
        </div>
        <div className="stat-tile stat-tile--green">
          <dt>Точность</dt>
          <dd>{Math.round(accuracy * 100)}%</dd>
        </div>
        <div className="stat-tile stat-tile--blue">
          <dt>Слова</dt>
          <dd>{newWords}</dd>
        </div>
      </dl>

      <div className="complete__footer">
        <button type="button" className="btn btn--primary btn--block" onClick={onContinue}>
          {continueLabel}
        </button>
      </div>
    </div>
  );
}
